module.exports = __webpack_public_path__ + "static/img/rank_264.47df759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_264.png
// module id = PDMj
// module chunks = 1